// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--RKvk8";
export var cdsAssistiveText = "Accordion-module--cds--assistive-text--MzLBz";
export var cdsVisuallyHidden = "Accordion-module--cds--visually-hidden--yKgnq";
export var hideFeedback = "Accordion-module--hide-feedback--kImKC";
export var showFeedback = "Accordion-module--show-feedback--YG89H";
export var skeleton = "Accordion-module--skeleton--t3tYj";